import { useLayoutEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { UserStatus } from '../../types/UserStatus.enum'

export const useAmpUserStatus = (): UserStatus => {
  const [status, setStatus] = useState<UserStatus>(() => {
    const lastAuthState = Cookies.get('lastAmpAuthState')
    if (lastAuthState === 'active') {
      return UserStatus.CLIENT_ACTIVE
    } else if (lastAuthState === 'expired') {
      return UserStatus.CLIENT_EXPIRED
    } else {
      return UserStatus.PROSPECT
    }
  })

  useLayoutEffect(() => {
    const lastAuthState = Cookies.get('lastAmpAuthState')
    if (lastAuthState === 'active') {
      setStatus(UserStatus.CLIENT_ACTIVE)
    } else if (lastAuthState === 'expired') {
      setStatus(UserStatus.CLIENT_EXPIRED)
    } else {
      setStatus(UserStatus.PROSPECT)
    }
  }, [])

  return status
}
